export default __webpack_public_path__ + "static/media/default.a3dbb643030a908c3e7248524894a36b.svg";